import * as React from "react";

import type { KeyboardShortcutCommand, KeyboardShortcutScope } from "./keyboard-shortcuts";

export interface ShortcutRegistration {
  id: symbol;
  scope: KeyboardShortcutScope;
  commands: () => KeyboardShortcutCommand[];
  active: () => boolean;
  element?: () => HTMLElement | null;
}

export interface KeyboardShortcutsContextValue {
  register: (registration: ShortcutRegistration) => () => void;
  claimTable: (id: symbol) => void;
  refresh: () => void;
}

// This identity lives outside the hot-reloaded provider/hook implementation so
// mounted providers and refreshed consumers cannot drift onto different contexts.
export const KeyboardShortcutsContext = React.createContext<KeyboardShortcutsContextValue | null>(
  null,
);
